import { useEffect, useState } from "react";
import headerLeftLogo from "../../../headerLeftLogo.png"
import headerRightLogo from "../../../headerRightLogo.png"
import footerImage from "../../../footerImage.png"
import headerImage from "../../../headerFullImage.png"
import "./QuotePDFNewCommonStyleSheet.scss";
import FetchData, { GetOne, GetListAsync } from "../../../providers/dataProvider";
import { useLocation } from "react-router-dom";
import { CheckNull, PriceFormat, formatDate, numberToWords, FormatValueDecimal, getStorageData, CurrencyConvertion } from "../../../utils/Validate";
import urls from "../../../constants";
import moment from "moment";
import NewTermsAndConditions from "./NewTermsAndConditions";
import usePrintWithFilename from "../../../hooks/usePrintWithFilename";

const QuotePDFNewDetail = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    const location = useLocation();
    const [quotePDFDetails, setQuotePDFDetails] = useState(null);
    const [customerObj, setCustomer] = useState(null);
    const [projectObj, setProject] = useState(null);
    const [markDetails, setMarkDetails] = useState([]);
    const [markData, setMarkData] = useState(null);
    const [configData, setConfigData] = useState(null);
    const [variantData, setVariantData] = useState([]);
    const [distributorImage, setDistributorImage] = useState(null);
    const [listData, setListData] = useState([])
    const queryParams = new URLSearchParams(location.search);
    const quoteId = queryParams.get("id");

    const { data: currencyList } = FetchData("currency");
    const { data: assignedEngineerList } = FetchData("userprofile");
    const { data: deliveryTermsList } = FetchData("deliveryterms");
    const { data: paymentTermsList } = FetchData("paymentterms");
    const { data: countryList } = FetchData("country");
    const { data: distributorList } = FetchData("distributor");

    const salesEngObj = assignedEngineerList?.find((ob) => ob?.identityId == quotePDFDetails?.data?.salesEngineerId);
    const currencyDetail = currencyList?.find(item => item?.id === quotePDFDetails?.data?.currencyId);

    useEffect(() => {
        if (quoteId) {
            GetOne("quotation", { id: quoteId }, setQuotePDFDetails);
        }
    }, [quoteId]);

    useEffect(() => {
        if (salesEngObj?.id) {
            GetOne("userprofile", { id: salesEngObj?.id }, setListData)
        }
    }, [salesEngObj]);

    useEffect(() => {
        if (quotePDFDetails?.data) {
            GetOne("Customer", { id: quotePDFDetails?.data?.customerId }, setCustomer);
            GetOne("project", { id: quotePDFDetails?.data?.projectId }, setProject);
        }
    }, [quotePDFDetails]);

    useEffect(() => {
        const fetchProductData = async () => {
            const quoteDetails = quotePDFDetails?.data;
            if (quoteDetails?.products) {
                try {
                    const configDataPromises = quoteDetails.products.map(item =>
                        GetListAsync("productsspecification", { id: item?.productId })
                    );
                    const configDataResults = await Promise.all(configDataPromises);
                    const configResult = configDataResults
                        .filter(result => result?.message === "success")
                        ?.map((item) => [...item?.data])
                        ?.flat();

                    const VariantPromises = quoteDetails.products.map(item =>
                        GetListAsync("productsvariants", { id: item?.groupId }).then(result => ({
                            markId: item.id,
                            result,
                        }))
                    );
                    const VariantDataResult = await Promise.all(VariantPromises);
                    const variantResult = VariantDataResult.filter(result => result?.result?.message === "success");

                    setVariantData(variantResult);
                    setMarkData(quoteDetails?.products);
                    setConfigData(configResult);
                    GetMarkDetails(quoteDetails?.products, configResult);
                } catch (error) {
                    console.error("Error fetching product data", error);
                }
            }
        };

        fetchProductData(); // Call the async function
    }, [quotePDFDetails]);

    const GetMarkDetails = (markResult, configResult) => {
        if (markResult?.length > 0) {
            let arrayMark = [];
            markResult?.map((item) => {
                const productFilterObj = configResult?.filter((config) => config?.productId === item?.productId);
                let arrayAttribute = [];
                item?.productSpecifications?.map((spec) => {
                    const findAttribute = productFilterObj
                        ?.map((productItem) => productItem?.productSpecMaps)
                        ?.flat()
                        .filter(specItem => specItem?.attributeId === spec?.specificationId);
                    const findvalue = findAttribute?.[0]?.productSpecValueMaps?.filter(
                        valuemap => valuemap?.id === spec?.specificationValueId
                    );
                    arrayAttribute.push({
                        ...spec,
                        attributeName: findAttribute?.[0]?.attributeName,
                        attributeValue: findvalue?.[0]?.valueName
                    });
                });
                arrayMark?.push({ ...item, productSpecifications: arrayAttribute });
            });
            setMarkDetails(arrayMark);
        }
    };

    const chunkArray = (array, chunkSize) => {
        const result = [];
        for (let i = 0; i < array.length; i += chunkSize) {
            result.push(array.slice(i, i + chunkSize));
        }
        return result;
    };

    const renderSpecifications = (mark) => {
        const specChunks = chunkArray(mark?.productSpecifications, 2);
        return specChunks.map((specChunk, rowIndex) => (
            <tr key={rowIndex}>
                {specChunk.map((specification, specIndex) => (
                    <td key={specIndex} colSpan="4" className="white-space-nowrap">
                        <span>{specification?.attributeName}{" : "}</span>
                        {specification?.specialValue ? specification?.specialValue : specification?.attributeValue}
                    </td>
                ))}
            </tr>
        ));
    };

    const getVariantValue = (variantId, prodItem) =>
        prodItem?.productItemVariants?.find(filterItem => variantId.includes(filterItem?.variantId))?.variantValue || "";

    const getAngleValue = (prodItem) =>
        prodItem?.productItemVariants?.find(filterItem => urls?.ANGLE.includes(filterItem?.variantId))?.variantValue || "";

    const shouldShowAngleColumn = (mark) =>
        mark?.productItems?.some((prodItem) =>
            prodItem?.productItemVariants?.some((variant) => urls?.ANGLE.includes(variant?.variantId))
        );

    const getQuantity = (prodItem) => {
        const variantQty = prodItem?.productItemVariants?.find(
            filterItem => urls?.QUANTITY_CONSTANT.includes(filterItem?.variantId)
        )?.variantValue;
        return variantQty ?? prodItem?.quantity ?? 0;
    };

    const DAMPER_WIDTH_HEIGHT_GROUPS = [
        urls.COMBINATION_FIRE_SMOKE_GROUP_ID,
        urls.FIRE_DAMPER_GROUP_ID,
        urls.SMOKE_DAMPER_GROUP_ID,
        urls.STEEL_CONTROL_DAMPER,
        urls.DUCT_ACCESS_DOORS,
    ];

    const renderProductHeading = (mark) => {
        let dimensions = "";
        if (urls?.LENGTH_NO_OF_SLOTS_GROUP.includes(mark?.groupId)) {
            if (urls?.LENGTH1_LENGTH2_SLOTS_PRODUCT.includes(mark?.productSubGroupId))
                dimensions = `Dimensions ~ <br/> L1 (mm) x L2 (mm) x Slot (mm)`;
            else
                dimensions = `Dimensions ~ <br/> L (mm) x Slot (mm) x EndCaps`;
        } else if (urls?.LENGTH_HEIGHT_GROUP.includes(mark?.groupId)) {
            if (urls?.MITER_CORNER_PRODUCT_ID === mark?.productSubGroupId)
                dimensions = `Dimensions ~ <br/> L1 (mm) x L2 (mm) x H (mm)`;
            else
                dimensions = `Dimensions ~ <br/> L (mm) x H (mm)`;
        } else if (mark?.groupId === urls?.VAV_GROUP_ID || mark?.groupId === urls?.PRESSURE_VAV_GROUP_ID)
            dimensions = `Dimensions ~ <br/> Dia (mm)`;
        else if (urls?.WIDTH_HEIGHT_GROUP.includes(mark?.groupId) || DAMPER_WIDTH_HEIGHT_GROUPS.includes(mark?.groupId))
            dimensions = `Dimensions ~ <br/> W (mm) x H (mm)`;
        else if (urls?.DIAMETER_GROUP.includes(mark?.groupId))
            dimensions = `Dimensions ~ <br/> Dia (mm)`;
        else
            dimensions = `Dimensions`;
        return dimensions;
    };

    const renderProductDetail = (mark, prodItem) => {
        let dimensions = "";
        if (urls?.LENGTH_NO_OF_SLOTS_GROUP.includes(mark?.groupId)) {
            if (urls?.LENGTH1_LENGTH2_SLOTS_PRODUCT.includes(mark?.productSubGroupId))
                dimensions = `${getVariantValue(urls.LENGTH_1, prodItem)} x ${getVariantValue(urls.LENGTH_2, prodItem)} x ${getVariantValue(urls.NO_OF_SLOTS, prodItem)}`;
            else if (urls?.CURVED_LENGTH_PRODUCT_ID.includes(mark?.productSubGroupId))
                dimensions = `${getVariantValue(urls.ARC_LENGTH, prodItem)} x ${getVariantValue(urls.NO_OF_SLOTS, prodItem)} x ${getVariantValue(urls.END_CAPS, prodItem)}`;
            else
                dimensions = `${getVariantValue(urls.LENGTH, prodItem)} x ${getVariantValue(urls.NO_OF_SLOTS, prodItem)} x ${getVariantValue(urls.END_CAPS, prodItem)}`;
        } else if (urls?.LENGTH_HEIGHT_GROUP.includes(mark?.groupId)) {
            if (urls?.MITER_CORNER_PRODUCT_ID === mark?.productSubGroupId)
                dimensions = `${getVariantValue(urls.LENGTH_1, prodItem)} x ${getVariantValue(urls.LENGTH_2, prodItem)} x ${getVariantValue(urls.HEIGHT, prodItem)}`;
            else if (urls?.CURVED_LINEARBAR_GRILL_PRODUCT_ID === mark?.productSubGroupId)
                dimensions = `${getVariantValue(urls.ARC_LENGTH, prodItem)} x ${getVariantValue(urls.HEIGHT, prodItem)}`;
            else
                dimensions = `${getVariantValue(urls.LENGTH, prodItem)} x ${getVariantValue(urls.HEIGHT, prodItem)}`;
        } else if (mark?.groupId === urls?.VAV_GROUP_ID || mark?.groupId === urls?.PRESSURE_VAV_GROUP_ID)
            dimensions = `${getVariantValue(urls.VAV_INLET_DIA, prodItem)}`;
        else if (urls?.WIDTH_HEIGHT_GROUP.includes(mark?.groupId) || DAMPER_WIDTH_HEIGHT_GROUPS.includes(mark?.groupId))
            dimensions = `${getVariantValue(urls.WIDTH, prodItem)} x ${getVariantValue(urls.HEIGHT, prodItem)}`;
        else if (urls?.DIAMETER_GROUP.includes(mark?.groupId))
            dimensions = `${getVariantValue(urls.DIAMETER, prodItem)}`;
        else
            dimensions = "";
        return dimensions;
    };

    const getTagRefValue = (prodItem) => {
        const standard = prodItem?.productItemVariants?.find(
            filterItem => urls?.TAG_REF_CONSTANT.includes(filterItem?.variantId)
        )?.variantValue;
        if (standard) return standard;
        const fallback = prodItem?.productItemVariants?.find(
            filterItem => filterItem?.variantName?.toLowerCase().includes("tag")
        )?.variantValue;
        return fallback || "";
    };

    const getOtherRefValue = (prodItem) => {
        const standard = prodItem?.productItemVariants?.find(
            filterItem => urls?.OTHER_REF_CONSTANT?.includes(filterItem?.variantId)
        )?.variantValue;
        if (standard) return standard;
        const fallbacks = prodItem?.productItemVariants?.find(
            filterItem => filterItem?.variantName?.toLowerCase()?.includes("other")
        )?.variantValue;
        return fallbacks || "";
    };

    const getUnitPriceValue = (prodItem) => {
        const unitPrice = prodItem?.productItemVariants?.find(
            item => urls.UNIT_PRICE_CONSTANT.includes(item.variantId)
        )?.variantValue;

        const netUnitPrice = prodItem?.productItemVariants?.find(
            item => urls.NET_UNIT_PRICE_CONSTANT.includes(item.variantId)
        )?.variantValue;

        const price = Number(prodItem?.unitPrice);

        return Number(price.toFixed(2));
    };

    const specialChargesValue = Number(quotePDFDetails?.data?.specialCharges) || 0;

    const getMarkSubtotal = (mark) => {
        return mark?.productItems?.reduce((sum, prodItem) => {
            const quantity = Number(getQuantity(prodItem)) || 0;
            const ddpPercentage = 1 - mark?.ddpPercentage
            const unitPrice = getUnitPriceValue(prodItem);
            const filteredUniPrice = unitPrice / parseFloat(ddpPercentage)
            return sum + (filteredUniPrice * quantity);
        }, 0) || 0;
    };
    const handlePrint = usePrintWithFilename(quotePDFDetails?.data?.quoteReference);

    useEffect(() => {
        const userProf = getStorageData();
        const userProfId = userProf?.userCompanyId;
        const distributorUrl = distributorList?.find(item => item?.id === userProfId);
        setDistributorImage({ distributorUrl: distributorUrl, userProf: userProf });
    }, [distributorList]);

    const netPrice = markDetails?.reduce((total, mark) => {
        return parseFloat((total + getMarkSubtotal(mark)).toFixed(2));
    }, 0) || 0;

    const taxAmount = (() => {
        const data = quotePDFDetails?.data;
        if (!data) return 0;
        if (data?.tax > 0) return data.tax * 1;
        if (data?.taxPercentage > 0) return netPrice * (data.taxPercentage * 1 / 100);
        return 0;
    })();

    const totalExworksPrice = (quotePDFDetails?.data?.netPrice * 1) + (quotePDFDetails?.data?.specialCharges * 1)
    const customDutyValue = quotePDFDetails?.data?.customDuty ? quotePDFDetails?.data?.customDuty * 1 : (((totalExworksPrice * 1) + (quotePDFDetails?.data?.freightCharges * 1)) * ((quotePDFDetails?.data?.customDutyPercentage * 1) / 100))
    const clearnceValue = quotePDFDetails?.data?.clearanceCharges ? quotePDFDetails?.data?.clearanceCharges * 1 : (((totalExworksPrice * 1) + (quotePDFDetails?.data?.freightCharges * 1) + (customDutyValue * 1)) * ((quotePDFDetails?.data?.clearanceChargesPercentage * 1) / 100))
    const totalLandedCost = ((totalExworksPrice * 1) + (quotePDFDetails?.data?.freightCharges * 1) + (customDutyValue * 1) + (clearnceValue * 1))
    const salesMarginValue = totalLandedCost * 1
    const grandTotal = taxAmount + salesMarginValue


    const showTaxRow = (quotePDFDetails?.data?.tax > 0 || quotePDFDetails?.data?.taxPercentage > 0);
    const showGrandTotalRow = grandTotal > 0;

    return (
        <>

            <div className="container">
                <div className="row">
                    <div className="col-12 text-end">
                        <div className="print-btn-container">
                            <button onClick={() => handlePrint()} className="btn pdf-print-btn my-2">Export to PDF</button>
                        </div>
                    </div>
                    <div className="col-12">
                        <table className="bg-white page">
                            <thead>
                                <tr>
                                    <td className="boder-none p-0">
                                        <div className="page-header position-relative">
                                            <table className="quotation-summary-pdf-table-head w-100">
                                                <tr>
                                                    <th className="text-start pt-0 pl-0 position-relative">
                                                        <img className="w-100" src={distributorImage?.userProf?.userType === 2 ? distributorImage?.distributorUrl?.headerUrl : headerImage} />
                                                        <div className="quotation-text">QUOTATION</div>
                                                    </th>
                                                </tr>
                                            </table>
                                        </div>
                                    </td>
                                </tr>
                            </thead>

                            <tbody className="page-content">
                                <tr>
                                    <td className="boder-none">
                                        <div className="page">
                                            <table className="customer-details-table">
                                                <tbody>
                                                    <tr>
                                                        <td className="w-50 border-right">
                                                            <table>
                                                                <tbody>
                                                                    <tr>
                                                                        <td>Customer <span className="float-right">:</span></td>
                                                                        <td>{customerObj?.data?.customerName}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Address <span className="float-right">:</span></td>
                                                                        <td>{quotePDFDetails?.data?.customerAddress}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Contact Person <span className="float-right">:</span></td>
                                                                        <td>{quotePDFDetails?.data?.contactPerson}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Contact # <span className="float-right">:</span></td>
                                                                        <td>{quotePDFDetails?.data?.phone}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                        <td className="w-50">
                                                            <table className="w-100">
                                                                <tbody>
                                                                    <tr>
                                                                        <td>Quote Ref <span className="float-right">:</span></td>
                                                                        <td>{quotePDFDetails?.data?.quoteReference}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Date <span className="float-right">:</span></td>
                                                                        <td>{formatDate(quotePDFDetails?.data?.createdAt, "")}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Customer Email <span className="float-right">:</span></td>
                                                                        <td>{quotePDFDetails?.data?.emailAddress}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Sales Eng <span className="float-right">:</span></td>
                                                                        <td>{salesEngObj?.firstName + " " + salesEngObj?.lastName}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Contact <span className="float-right">:</span></td>
                                                                        <td>{listData?.data?.phone}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="border-top" colspan="2">
                                                            <table>
                                                                <tbody>
                                                                    <tr>
                                                                        <td className="w-12">Project<span className="float-right">:</span></td>
                                                                        <td colspan="4">{projectObj?.data?.projectName}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <table className="w-100 mt-1 mb-1 border-0">
                                                <tbody>
                                                    <tr>
                                                        <td className="border-0"> Dear Sir/Madam, <br />
                                                            We thank you for your enquiry and are pleased to submit our proposal as follows:
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            {markDetails?.map((mark, index) => {
                                                const markSubTotal = getMarkSubtotal(mark);
                                                const showAngleColumn = shouldShowAngleColumn(mark);
                                                return (
                                                    <table className="product-table" key={index}>
                                                        <thead>
                                                            <tr>
                                                                <td className="border-right-none" colSpan="4">
                                                                    <span><strong>MODEL :</strong></span> <strong>{mark?.productName}</strong>
                                                                </td>
                                                                <td colSpan="4" className="text-end border-left-none">
                                                                    <span><strong>PRODUCT :</strong></span> <strong>{mark?.groupName}</strong>
                                                                </td>
                                                            </tr>
                                                            {renderSpecifications(mark)}
                                                            <tr>
                                                                <th className="text-center">#</th>
                                                                <th className="text-center">Tag Ref.</th>
                                                                <th className="text-center" dangerouslySetInnerHTML={{ __html: renderProductHeading(mark) }}></th>
                                                                {showAngleColumn && (
                                                                    <th className="text-center">Angle</th>
                                                                )}
                                                                <th className="text-center">Qty<br /> (nos)</th>
                                                                <th className="text-center white-space-nowrap">Unit Price <br />({currencyDetail?.shortCode})</th>
                                                                <th className="text-center">Total Price <br />({currencyDetail?.shortCode})</th>
                                                                <th className="text-center">Notes</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {mark?.productItems?.map((prodItem, prodIndex) => {

                                                                const quantity = getQuantity(prodItem);
                                                                let itemListPrice = prodItem?.productItemVariants?.find(filterItem => urls?.LIST_PRICE_CONSTANT.includes(filterItem?.variantId))?.variantValue || 0
                                                                const ddpPercentage = 1 - mark?.ddpPercentage

                                                                const unitPrice = getUnitPriceValue(prodItem);
                                                                const filteredUniPrice = unitPrice / parseFloat(ddpPercentage)

                                                                const rowTotal = parseFloat((filteredUniPrice * quantity).toFixed(2));
                                                                let filterVariant = variantData?.find(varItem => varItem.markId === prodItem?.quoteProductId)?.result;
                                                                let includePrint = filterVariant?.data?.filter(item => item.includeInPrint === true);

                                                                const tagRefValue = getTagRefValue(prodItem);
                                                                const otherRefValue = getOtherRefValue(prodItem)
                                                                const dimensionDetail = renderProductDetail(mark, prodItem);
                                                                const angleValue = showAngleColumn ? getAngleValue(prodItem) : null;

                                                                return (
                                                                    <tr key={prodIndex}>
                                                                        <td className="text-center">{prodIndex + 1}</td>
                                                                        <td className="text-center">{tagRefValue}</td>
                                                                        <td className="text-center">{dimensionDetail}</td>
                                                                        {showAngleColumn && (
                                                                            <td className="text-center">{angleValue}</td>
                                                                        )}
                                                                        <td className="text-center">{quantity}</td>
                                                                        {/* <td className="text-end">
                                                                            {FormatValueDecimal(CurrencyConvertion(prodItem?.listPrice, quotePDFDetails?.data?.conversionRate, currencyDetail))}
                                                                        </td> */}
                                                                        <td className="text-end">
                                                                            {FormatValueDecimal(CurrencyConvertion(filteredUniPrice, quotePDFDetails?.data?.conversionRate, currencyDetail))}
                                                                        </td>
                                                                        <td className="text-end">
                                                                            {FormatValueDecimal(CurrencyConvertion(rowTotal, quotePDFDetails?.data?.conversionRate, currencyDetail))}
                                                                        </td>
                                                                        <td className="text-left">
                                                                            {/* {includePrint?.length > 0 && (() => {
                                                                                const variantValues = includePrint
                                                                                    ?.map(inprintItem =>
                                                                                        prodItem?.productItemVariants?.find(
                                                                                            filterItem => inprintItem?.variantId === filterItem?.variantId
                                                                                        )?.variantValue || 0
                                                                                    )
                                                                                    .filter(value => value > 0);
                                                                                return variantValues.length > 0 ? (
                                                                                    <p className="white-space-nowrap">
                                                                                        Face Size(mm): {variantValues.join(" x ")}
                                                                                    </p>
                                                                                ) : null;
                                                                            })()} */}
                                                                            {prodItem?.notes?.length > 0 && (
                                                                                <p className="mt-2">{prodItem?.notes}</p>
                                                                            )}
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                        <tfoot>
                                                            <tr>
                                                                <td colSpan={showAngleColumn ? "6" : "5"} className="text-end"><strong>Sub Total:</strong></td>
                                                                <td colSpan="1" className="text-end">

                                                                    <strong>
                                                                        {FormatValueDecimal(CurrencyConvertion(markSubTotal, quotePDFDetails?.data?.conversionRate, currencyDetail))}
                                                                    </strong>
                                                                </td>
                                                                <td></td>
                                                            </tr>
                                                        </tfoot>
                                                    </table>
                                                );
                                            })}

                                            <table className="net-price-table w-100 mt-5px">
                                                <tbody>
                                                    <tr>
                                                        <td className="text-end" colSpan="3">Net Price <span className="float-right">:</span></td>
                                                        <td className="text-center" style={{ width: "15%" }}>{currencyDetail?.shortCode}</td>
                                                        <td className="text-end">
                                                            {FormatValueDecimal(CurrencyConvertion(netPrice, quotePDFDetails?.data?.conversionRate, currencyDetail))}
                                                        </td>
                                                    </tr>

                                                    {/* Special Charges */}
                                                    {specialChargesValue > 0 && (
                                                        <tr>
                                                            <td className="text-end" colSpan="3">
                                                                Special Charges <span className="float-right">:</span>
                                                            </td>
                                                            <td className="text-center" style={{ width: "15%" }}>{currencyDetail?.shortCode}</td>
                                                            <td className="text-end">
                                                                {FormatValueDecimal(CurrencyConvertion(specialChargesValue, quotePDFDetails?.data?.conversionRate, currencyDetail))}
                                                            </td>
                                                        </tr>
                                                    )}



                                                    {/* Tax */}
                                                    {showTaxRow && (
                                                        <tr>
                                                            <td className="text-end" colSpan="3">
                                                                Taxes / VAT {quotePDFDetails?.data?.tax > 0 ? "" : "@ " + quotePDFDetails?.data?.taxPercentage + "%"}
                                                                <span className="float-right">:</span>
                                                            </td>
                                                            <td className="text-center" style={{ width: "15%" }}>{currencyDetail?.shortCode}</td>
                                                            <td className="text-end">
                                                                {FormatValueDecimal(CurrencyConvertion(taxAmount, quotePDFDetails?.data?.conversionRate, currencyDetail))}
                                                            </td>
                                                        </tr>
                                                    )}

                                                    {/*Grand Total */}
                                                    {showGrandTotalRow && (
                                                        <tr className="border-top">
                                                            <td className="text-end" colSpan="3"><strong>Grand Total</strong> <span className="float-right">:</span></td>
                                                            <td className="text-center" style={{ width: "15%" }}><strong>{currencyDetail?.shortCode}</strong></td>
                                                            <td className="text-end">
                                                                <strong>
                                                                    {FormatValueDecimal(CurrencyConvertion(grandTotal, quotePDFDetails?.data?.conversionRate, currencyDetail))}
                                                                </strong>
                                                            </td>
                                                        </tr>
                                                    )}

                                                    <tr className="border-top">
                                                        <td className="text-start"><strong>TOTAL (in words)</strong><span>:</span></td>
                                                        <td className="text-start" colSpan="3">
                                                            <strong>
                                                                {numberToWords(CurrencyConvertion(grandTotal, quotePDFDetails?.data?.conversionRate, currencyDetail), currencyDetail)}
                                                            </strong>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <table className="terms-conditions-table w-100 mt-5px border-0">
                                                <thead>
                                                    <tr>
                                                        <th className="text-start" colSpan="2"> Terms &amp; Conditions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td className="text-start">Payment Terms
                                                            <span className="float-right">:</span>
                                                        </td>
                                                        <td className="text-start"> {quotePDFDetails?.data?.paymentTerms || paymentTermsList?.find(item => item?.id === quotePDFDetails?.data?.paymentTermId)?.paymentDescription}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="text-start">Delivery Terms <span className="float-right">:</span></td>
                                                        <td className="text-start">
                                                            {quotePDFDetails?.data?.deliveryTerms
                                                                || deliveryTermsList?.find(item => item?.id === quotePDFDetails?.data?.deliveryTermId)?.deliveryDescription
                                                                || quotePDFDetails?.data?.destination}
                                                            {countryList?.find(country => country?.id === quotePDFDetails?.data?.destinationCountryId)?.name
                                                                && (countryList?.find(country => country?.id === quotePDFDetails?.data?.destinationCountryId)?.name)}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="text-start">Delivery Period <span className="float-right">:</span></td>
                                                        <td className="text-start">As per the project requirement</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="text-start">Validity <span className="float-right">:</span></td>
                                                        <td className="text-start"> {quotePDFDetails?.data?.quoteValidity} days from the date hereof and thereafter subject to our written
                                                            confirmation.</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="text-start">Warranty <span className="float-right">:</span></td>
                                                        <td className="text-start"> Goods manufactured by Jersey Manufacturing carry a standard warranty of 12
                                                            months from the date of supply,
                                                            against all manufacturing defects, subject to our warranty policy - (can be provided on
                                                            request).</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <table className="w-100 mt-1 mb-1 border-0">
                                                <tbody>
                                                    <tr>
                                                        <td className="border-0"> We once again thank you for the opportunity to quote for your requirement. Please feel free to contact us in case of any clarification. <br />
                                                            Thanking you and assuring you our best attention and services at all times.
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="border-0 pt-3"> For, Jersey Manufacturing for Airconditioning Products
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <table className="signature-table w-100 mt-1 mb-1 border-0 mt-5">
                                                <tbody>
                                                    <tr>
                                                        <td className="text-center border-0"> Sales Engineer
                                                        </td>
                                                        <td className="text-center border-0">  Divisional manager</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colSpan="9" className="border-0 pb-0">
                                        <div className="page-footer-space"></div>
                                        <div className="page-quote-footer w-100">
                                            <table className="footer-quote-logo-table w-100 border-0">
                                                <tbody>
                                                    <tr>
                                                        <td className="text-start border-0 pl-0">Quote Ref # : {quotePDFDetails?.data?.quoteReference}</td>
                                                        <td className="text-end border-0">{moment(new Date()).format("DD-MMM-YYYY hh:mm A")}</td>
                                                        <td className="text-end border-0 pr-40">QR/DR-N/2021 RDO</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </td>
                                </tr>
                            </tfoot>
                            <tfoot>
                                <tr>
                                    <td colSpan="9" className="border-0">
                                        <div className="page-footer w-100">
                                            <table className="footer-logo-table w-100 border-0">
                                                <tbody>
                                                    <tr className="border-top">
                                                        <th className="text-start pl-0 pr-0 border-0 pt-0 pb-0" colSpan="9">
                                                            <img src={distributorImage?.userProf?.userType === 2 ? distributorImage?.distributorUrl?.footerUrl : footerImage} alt="Footer Logo" className="footer-logo w-100" />
                                                        </th>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </td>
                                </tr>
                            </tfoot>

                        </table>
                    </div>
                </div>
            </div>
            <NewTermsAndConditions distributorImage={distributorImage} />
        </>


    );
};

export default QuotePDFNewDetail;